import { useGetUser } from "@/hooks/queryHooks/userHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Link } from "react-router-dom";

export const UserSummaryItem = ({
  tenantId,
  userId,
}: {
  tenantId: string;
  userId: string;
}) => {
  const { data: user } = useGetUser(userId);
  const path = userId ? new AppUrlPath(tenantId).getUserPath(userId) : "";

  return (
    <Link className="block hover:underline" to={path}>
      {!userId
        ? "Unknown"
        : user
          ? `${user.firstName} ${user.lastName}`.trim() || "<Empty Username>"
          : "Loading..."}
    </Link>
  );
};
